import { render, staticRenderFns } from "./CommonLogin.vue?vue&type=template&id=1b51c0aa&"
import script from "./CommonLogin.vue?vue&type=script&lang=js&"
export * from "./CommonLogin.vue?vue&type=script&lang=js&"
import style0 from "./CommonLogin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports